import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconName} from '@fortawesome/fontawesome-svg-core';
import getSaebComparisonMessage, {
  SaebComparisonTrend,
} from 'utils/functions/getSaebComparisonMessage';
import {DEFAULT_QUESTION_COUNT} from 'utils/functions/getSaebReadingLevel';
import styles from './SaebComparisonSection.module.scss';

export interface SaebComparisonSectionProps {
  previousCorrect: number;
  currentCorrect: number;
  questionCount?: number;
}

// Hex directly in the `color` prop, same pattern as other FontAwesomeIcon uses
// in the repo. Values match $success/$primary-yellow/$grey.
const TREND_ICON: Record<SaebComparisonTrend, {icon: IconName; color: string}> =
  {
    up: {icon: 'circle-up', color: '#00c660'},
    down: {icon: 'circle-down', color: '#f3af31'},
    same: {icon: 'equals', color: '#95989a'},
  };

function SaebComparisonSection({
  previousCorrect,
  currentCorrect,
  questionCount = DEFAULT_QUESTION_COUNT,
}: SaebComparisonSectionProps) {
  const message = getSaebComparisonMessage(previousCorrect, currentCorrect);
  const trendIcon = TREND_ICON[message.trend];

  return (
    <section className={styles.container}>
      <div className={styles.eyebrow}>
        <FontAwesomeIcon
          icon={['fad', trendIcon.icon]}
          color={trendIcon.color}
          aria-hidden="true"
        />
        Sua evolução na leitura
      </div>

      <h3 className={styles.heading}>{message.heading}</h3>
      <p className={styles.text}>{message.text}</p>

      <div className={styles.grid}>
        <div className={styles.card}>
          <span className={styles.score}>
            {previousCorrect} de {questionCount}
          </span>
          {/* "Sua primeira atividade"/"Esta atividade" em vez de "Atividade 1"/"Atividade 3" —
          numeração interna confundia o aluno (achado do usuário, 2026-09-24). */}
          <span className={styles.label}>Sua primeira atividade</span>
        </div>
        <div className={`${styles.card} ${styles.current}`}>
          <span className={styles.score}>
            {currentCorrect} de {questionCount}
          </span>
          <span className={styles.label}>Esta atividade</span>
        </div>
      </div>
    </section>
  );
}

export default SaebComparisonSection;
